import React, {  useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";

const { forwardRef, useRef, useImperativeHandle } = React;

const AssignPermissionSelect = forwardRef(
  ({ oldPermissions, onChange, label }, ref) => {
    const [permissionData, setPermissionData] = useState([]);

    const getPermissions = async () => {
      const path = "admin/permissions";
      try {
        const response = await getApi({ path });
        setPermissionData(response?.data.data.result.docs);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      getPermissions();
    }, []);

    const [permissionsOption, setPermissionsOption] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setSelectedPermissions([]);
      },
    }));

    useEffect(() => {
      if (permissionData?.length) {
        let newPermission = permissionData?.map((item) => {
          return {
            value: item._id,
            label: item.name,
          };
        });
        setPermissionsOption(newPermission);
      }
    }, [permissionData]);

    function handleAssignPermissions(data) {
      setSelectedPermissions(data);
      const newData = data.map((item) => {
        return item.value;
      });
      onChange(newData || []);
    }

    useEffect(() => {
      if (
        oldPermissions?.length > 0 &&
        permissionData?.length
      ) {
        let selectedPermissions = [];
        for (let i = 0; i < oldPermissions?.length; i++) {
          let isExist = permissionData.filter((item) => {
            return item.value == oldPermissions[i].resource;
          });
          selectedPermissions.push({
            value: isExist[0]?._id,
            label: isExist[0]?.name,
          });
          console.log(isExist);
        }
        console.log(selectedPermissions);
        setSelectedPermissions(selectedPermissions);
      }
    }, [oldPermissions, permissionData]);

    return (
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {label}
        </label>
        <Select
          className=""
          options={permissionsOption}
          placeholder="انتخاب سطح دسترسی"
          value={selectedPermissions}
          onChange={handleAssignPermissions}
          isSearchable={true}
          isMulti
        />
      </div>
    );
  }
);

export default AssignPermissionSelect;
